import { css, styled } from '@stitches/react'
import { theme } from '@styles/theme'

export const modalErrorReportStyles = {
	ModalContainer: styled('div', {
		width: '100%',
	}),
	ContainerTitle: styled('div', {
		display: 'flex',
		alignItems: 'center',
		marginBottom: '51px',
	}),
	Title: styled('h2', {
		textAlign: 'left',
		fontWeight: 'bold',
		fontSize: '24px',
		marginLeft: '16px',
	}),
	Label: styled('label', {
		fontSize: '20px',
		lineHeight: '18px',
		letterSpacing: '4%',
	}),
	RedText: styled('span', {
		color: theme.colors.red,
	}),
	FormGroup: styled('div', {
		gap: '20px',
		display: 'flex',
		flexDirection: 'column',
	}),
	Form: styled('div', {
		display: 'flex',
		flexDirection: 'column',
		gap: '32px',
	}),
	radioGroup: css({
		display: 'flex',
		flexDirection: 'row',
		gap: '32px',
	}),
	Info: styled('span', {
		fontSize: '18px',
		lineHeight: '25px',
		letterSpacing: '5%',
		color: theme.colors.neutral100,
	}),
	ButtonsContainer: styled('div', {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
	}),
	WarningContainer: styled('div', {
		display: 'flex',
		flexDirection: 'column',
	}),
	WarningRedText: styled('span', {
		color: theme.colors.red,
		fontSize: '18px',
		lineHeight: '25px',
		letterSpacing: '5%',
	}),
}
